module.exports = __webpack_public_path__ + "static/media/isdoctorplan-bariatric1@3x.a50904ea.png";